export enum dbKey {
  room = 'Classroom',
  cvn = 'Consolidated',
  act = 'Activity',
  sus = 'Suscribed',
  uid = 'fa37Q3WqWOUoXCLXyAm0kRwmQaJ2',
  ext = 'ExternalUser',
}
